<template>
    <div class="qrcode-login text-center">
        <div>请使用微信扫一扫</div>
        <img v-show="imageUrl" :src="imageUrl">
        <div class="qrcode alert alert-warning text-center" v-show="scanned">
            <span v-show="!agreed">扫描成功，请在手机端点击确认登录</span>
            <span v-show="agreed">确认成功，准备跳转</span>
        </div>
    </div>
</template>

<script type="text/ecmascript-6">
    import {mapGetters, mapMutations, mapState} from 'vuex'

    export default {
        props: {
            value: Object
        },
        data () {
            return {
                sceneCode: '',
                imageUrl: '',
                scanned: false,
                agreed: false,
            }
        },

        mounted(){
            console.log('mounted')
            if(this.mAppUrl){
                return this.createScene();
            }
            this.$http
                    .get(`/api/account/mAppUrl`)
                    .then(({data}) => {
                        this.SET_M_APP_URL(data.data.mAppUrl)
                        this.createScene()
                    })

        },
        computed:{
            ...mapState([
                'mAppUrl',
            ]),
        },
        destroyed(){
            if(this._timeoutId) {
                console.log('clear timeout interval')
                clearTimeout(this._timeoutId)
            }
        },
        methods: {
            ...mapMutations([
                'SET_M_APP_URL'
            ]),
            createScene(){
                this.sceneCode = (new Date().getTime() * Math.random() * 100).toFixed(0);
                var connnectUrl = `${this.mAppUrl}/#/login/ent/qrconnect/${this.sceneCode}`;
                this.imageUrl = '/api/qrcode?code=' + encodeURIComponent(connnectUrl)

                this.checkIsScanned();
            },
            checkIsScanned(){
                this.$http.post(`/api/qrconnect/checkScanned?code=${this.sceneCode}`,null, {
                    mask:false
                }).then(({data}) => {
                    if(data.success){
                        this.agreed = true;
                        return this.$emit('success')
                    }
                    if(data.errorCode == 1000){
                        this.createScene()
                    }
                    else if(data.errorCode == 1001){
                        this.scanned = true
                        this._timeoutId = setTimeout(this.checkIsScanned, 1000);
                    }
                    else{
                        this._timeoutId = setTimeout(this.checkIsScanned, 1000);
                    }
                });
            }
        }
    }
</script>

<style lang="scss" rel="stylesheet/scss">
    .qrcode-login {
        margin:0 0 10px 0;
    }

</style>



// WEBPACK FOOTER //
// src/modules/account/QrConnect.vue